export const EDIT_SUCCESS = 'Модель обновлена';
export const EDIT_ERROR = 'Не удалось обновить модель';
